import { Stack, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import ReportCount from "../../../components/SVGComponents/ReportCount";
import ImageCount from "../../../components/SVGComponents/ImageCount";
import RowBadge from "./Badge/RowBadge";
import { useNavigate } from "react-router";
import { getClientWarningStatus } from "../../../service/FirmServices";
import { t } from "i18next";
import {
  ACTIONS,
  AuthRoutes,
  CUSTOM_STYLES,
  TAB_NAME,
  USERTYPES,
} from "../../../constants/Constants";
import { RowBadgeStatic } from "./RadiologistDetails";
import userContext from "../../../context/users/UserContext";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";

const mainStackStyles = {
  // lineHeight: "20px",
  // height: "121px",
  // width: "210px",
  justifyContent: "center",
  marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
  // transform: "translateY(-39%)"
};

const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center",
  marginTop: "4px",
};

const superAdminStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center",
  marginTop: "2px",
};

const modalityStyle = {
  marginLeft: "10px",
  backgroundColor: "#BBDEFF",
  height: "14px",
  fontSize: "9px",
  color: "#0035BE",
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  fontWeight: "bolder",
  padding: "0px 5px",
  borderRadius: "5px",
};

const studyUploadDateStyle = {
  fontSize: "11px",
  fontWeight: "400",
};

const studyDetailsStackStyle = {
  alignItems: "center",
};

const studyDescriptionStyle = {
  fontSize: "11px",
  fontWeight: "400",
  marginRight: "20px",
};

const studyDetailsIconTextStyle = {
  fontSize: "14px",
  fontWeight: "400",
};

const ClientDetails = (props) => {
  const { roles, authenticated, loadByUsername, showConfirmation } =
    useContext(userContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (props.data.length > 0)
      if (!authenticated) {
        loadByUsername();
      }
  }, []);

  const clientDetailWithWarning = async (clientId) => {
    const response = await getClientWarningStatus(clientId);
    if (response.status == 200 && response.data.result === "SUCCESS") {
      //if (response.data.data.warning) {
        // let type = response.data.data.firmType === "Hospital" ? 0 : 1;
        let type = 0;
        let viewWarningOnly = true;
        const url =
        AuthRoutes.FIRMDETAILS +
        "?firmId=" +
        clientId +
        "&type=" +
        type +
        "&viewWarningOnly=" +
        viewWarningOnly;

      // Open the URL in a new tab
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus(); // Focus on the new tab
      }
     // }
    }
  };

  return (
    <>
      <Stack style={mainStackStyles} data-tut={"tour-client-details"}>
        { <>
          {roles[0] !== USERTYPES.ADMIN && (
            <Stack horizontal style={hospitalStackStyles}>
              {/* <span className="study-list-studyDetails-uploaded">Client :</span> */}
              <RowBadgeStatic name="C" tooltipText="Client" />
              {props.data.row.original.assignmentList[0].clientName !=
              undefined ? (
                // <RowBadge name={props.data.row.original.assignmentList[0].clientName} />
                <CustomToolTipHost
                  content={`${t("navbar.client")}: `+props.data.row.original.assignmentList[0].clientName}
                  id={
                    "tooltip_" +
                    props.data.row.original.assignmentList[0].clientName
                  }
                >
                  <span
                    className={`study-list-assignment-details-text study-list-row-badge ${(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR)?"hover-account-warning":""} study-list-min-width`}
                    style={{ width: "120px",display:'block' }}
                    onClick={() =>
                      {
                        console.log("---- Clicked Account Warning ---");
                        if((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR)){
                          clientDetailWithWarning(
                            props.data.row.original.assignmentList[0].clientId
                          )
                        }
                      }
                      
                    }
                  >
                    &nbsp;&nbsp;
                    {props.data.row.original.assignmentList[0].clientName}
                  </span>
                </CustomToolTipHost>
              ) : (
                <span
                  className="study-list-assignment-details-text study-list-row-badge"
                >
                  &nbsp;&nbsp;-
                </span>
              )}

              {/* <span>{props.data.row.original.assignmentList[0].clientName ? props.data.row.original.assignmentList[0].clientName : "-"}</span> */}
              {/* <div style={modalityStyle}>{props.data.row.original.modality.name}</div> */}
            </Stack>
          )}
         {(roles[0] === USERTYPES.ADMIN) && <Stack horizontal style={superAdminStackStyles}>
            {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
            <RowBadgeStatic name="F" tooltipText={t("navbar.firm")} />
            {props.data.row.original.assignmentList[0].firmId != null ? (
              // && props.data.row.original.assignmentList[0].providerId.startsWith(
              //   "F")
              //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />
              <CustomToolTipHost
                content={`${t("navbar.firm")}: `+props.data.row.original.assignmentList[0].firmName}
                id={
                  "tooltip_" +
                  props.data.row.original.assignmentList[0].firmName
                }
              >
                <span
                  className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                  style={{ width: "160px",display:'block' }}
                >
                  &nbsp;&nbsp;
                  {(props.data.row.original.assignmentList[0].firmName != "" || props.data.row.original.assignmentList[0].firmName != undefined)
                        ? props.data.row.original.assignmentList[0].firmName
                        : "-"}
                </span>
              </CustomToolTipHost>
            ) : (
              <>
                {roles[0] == USERTYPES.ADMIN &&
                props.data.row.original.assignmentList[0].firmId != null &&
                props.data.row.original.assignmentList[0].firmName != "" ? (
                  <CustomToolTipHost
                    content={props.data.row.original.assignmentList[0].firmName}
                    id={
                      "tooltip_" +
                      props.data.row.original.assignmentList[0].firmName
                    }
                  >
                    <span
                      className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                      style={{ width: "160px",display:'block' }}
                    >
                      &nbsp;&nbsp;
                      {props.data.row.original.assignmentList[0].firmName != ""
                        ? props.data.row.original.assignmentList[0].firmName
                        : "-"}
                    </span>
                  </CustomToolTipHost>
                ) : (
                  <span className="study-list-assignment-details-text study-list-row-badge">
                    &nbsp;&nbsp;{t("label.not-assigned")}
                  </span>
                )}
              </>
            )}
          </Stack>}
          {/* {(roles[0] == USERTYPES.SUPERVISOR ||
            roles[0] == USERTYPES.FIRMADMIN) &&
            props.tabId == TAB_NAME.QCREVIEW && (
              <Stack horizontal style={hospitalStackStyles}>
                
                <RowBadgeStatic name="QR" tooltipText="QC Reviewer" />
                {props.data.row.original.assignmentList[0].qcreviewerId !=
                  null &&
                props.data.row.original.assignmentList[0].qcreviewerId.startsWith(
                  "S"
                ) ? (

                  <span
                    className="study-list-studyDetails-uploaded study-list-row-badge"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcreviewerName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-studyDetails-uploaded study-list-row-badge">
                      &nbsp;&nbsp;Not Assigned
                    </span>
                  </>
                )}
              </Stack>
            )} */}
          {/* {((roles[0] == USERTYPES.SUPERVISOR && props.tabId == TAB_NAME.QCFIX ||
            roles[0] == USERTYPES.FIRMADMIN && props.tabId == TAB_NAME.QCFIX)
            ) && (
              <Stack horizontal style={hospitalStackStyles}>
                <RowBadgeStatic name="QF" tooltipText="QC Fixer" />
                {props.data.row.original.assignmentList[0].qcfixerId != null &&
                props.data.row.original.assignmentList[0].qcfixerId.startsWith(
                  "R"
                ) ? (

                  <span
                    className="study-list-studyDetails-uploaded study-list-row-badge"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcfixerName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcfixerName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcfixerName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-studyDetails-uploaded study-list-row-badge">
                      &nbsp;&nbsp;Not Assigned
                    </span>
                  </>
                )}
              </Stack>
            )} */}

{/* {((roles[0] == USERTYPES.SUPERVISOR && (props.tabId === TAB_NAME.QCREVIEW || props.tabId === TAB_NAME.QCVERIFY) )||
            (roles[0] == USERTYPES.FIRMADMIN && (props.tabId === TAB_NAME.QCREVIEW || props.tabId === TAB_NAME.QCVERIFY)))  && (
              <Stack horizontal style={hospitalStackStyles}>
                <RowBadgeStatic name="QR" tooltipText="QC Reviewer" />
                {props.data.row.original.assignmentList[0].qcreviewerId != null &&
                props.data.row.original.assignmentList[0].qcreviewerId.startsWith(
                  "S"
                ) ? (

                  <span
                    className="study-list-studyDetails-uploaded study-list-row-badge"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcreviewerName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcreviewerName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-studyDetails-uploaded study-list-row-badge">
                      &nbsp;&nbsp;Not Assigned
                    </span>
                  </>
                )}
              </Stack>
            )} */}

{/* {(((roles[0] == USERTYPES.SUPERVISOR && props.tabId === TAB_NAME.QCVERIFY ||
            (roles[0] == USERTYPES.FIRMADMIN && props.tabId == TAB_NAME.QCVERIFY)) 
            )) && (
              <Stack horizontal style={hospitalStackStyles}>
                <RowBadgeStatic name="QV" tooltipText="QC Verifier" />
                {props.data.row.original.assignmentList[0].qcverifierId != null &&
                props.data.row.original.assignmentList[0].qcverifierId.startsWith(
                  "S"
                ) ? (

                  <span
                    className="study-list-studyDetails-uploaded study-list-row-badge"
                    style={{ width: "160px" }}
                  >
                    &nbsp;&nbsp;
                    <CustomToolTipHost
                      content={
                        props.data.row.original.assignmentList[0].qcverifierName
                      }
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].qcverifierName
                      }
                    >
                      {props.data.row.original.assignmentList[0].qcverifierName}{" "}
                    </CustomToolTipHost>
                  </span>
                ) : (
                  <>
                    <span className="study-list-studyDetails-uploaded study-list-row-badge">
                      &nbsp;&nbsp;Not Assigned
                    </span>
                  </>
                )}
              </Stack>
            )} */}

          {/* <span style={studyUploadDateStyle}>
            {`Uploaded on ${props.data.row.original.uploadDateDisplay}`}
          </span> */}
       </> }
      </Stack>
    </>
  );
};

export default ClientDetails;
